import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M1.4 6c0-2.5 2-4.6 4.6-4.6h12c2.5 0 4.6 2 4.6 4.6v12c0 2.5-2 4.6-4.6 4.6H6c-2.5 0-4.6-2-4.6-4.6V6ZM6 3.4A2.6 2.6 0 0 0 3.4 6v12c0 1.4 1.2 2.6 2.6 2.6h12c1.4 0 2.6-1.2 2.6-2.6V6c0-1.4-1.2-2.6-2.6-2.6H6Zm2.9 3c.6-.3 1.2-.2 1.7.1l5.6 4.1c.4.3 1 .7 1 1.5s-.6 1.3-1 1.5l-5.5 3.9c-.5.2-1.2.5-1.9.1-.6-.3-.8-1-.8-1.6V8c0-.7.2-1.3.9-1.6Zm1 2.1 5 3.6-5 3.4v-7Z"
  />,
  'Play1'
)
